<template>
  <div>
    <sticky class="page-header sticky-page-header page-header--new" :back-button="true">
      <div slot="left-title">
        <h1 class="title is-3">
          <span class="is-uppercase has-text-black" v-if="!displayTopButtom && !opened">
            {{$route.name === 'StockLots' ? 'Lots' : 'Programmes'}}
          </span>
          <div class="column is-paddingless is-6 is-4-widescreen is-size-5 is-margin-neg-left columns" v-if="!bigLoading && (displayTopButtom || opened)">
            <div
              class="column has-bg-primary has-text-white has-text-centered is-uppercase" style="padding: 14px 0;">
              <span class="is-size-5 is-margin-left-xsmall is-margin-right-xsmall">{{`${programCount} programme(s) / ${lotCount} lot(s)`}}</span>
            </div>
          </div>
        </h1>
      </div>
      <div class="column is-paddingless is-border-left" slot="left-action" v-if="!isExternal && multiselection && selectedItems.length">
        <a @click="exportXlsFromMultiselect(exportData)"
          class="page-header-btn is-small is-success">
          <span class="icon"><i class="fas fa-file-excel"></i></span>
          <span>Exporter {{$route.name === 'StockLots' ? 'lots' : 'programmes'}} ({{selectedItems.length}})</span>
        </a>
      </div>
      <div class="column is-paddingless is-border-left" slot="left-action" v-if="(isAdmin || isEditor) && multiselection && selectedItems.length">
        <a @click="$route.name !== 'StockPrograms' ? changeLotStatusSelection() : changeProgramStatusSelection()"
          class="page-header-btn is-small">
          <span class="icon"><i class="fas fa-exchange-alt"></i></span>
          <span>Changer statut sélection</span>
        </a>
      </div>
      <div class="column is-paddingless is-border-left" slot="right-content">
        <a class="page-header-btn tooltip is-square is-tooltip-left is-tooltip-primary" :data-tooltip="fullscreen ? 'Réduire' : 'Agrandir'" @click="toggleFullscreen">
          <span class="icon">
            <i class="fal" :class="fullscreen ? 'fa-compress-wide' : 'fa-expand-wide'"></i>
          </span>
        </a>
      </div>
      <!-- Sous menu de Action-->
      <router-link v-if="(isAdmin || isEditor) && this.$route.path.includes('programmes') && !multiselection"
        slot="dropdown-content"
        :to="{name: 'ProgramCreate'}" class="dropdown-item"
      >
        <span class="icon"><i class="fas fa-plus-circle"></i></span>
        <span>Nouvelle fiche programme</span>
      </router-link>
      <router-link v-if="['admin', 'manager', 'seller', 'manager_ext', 'seller_ext', 'sector_manager'].includes(currentUserProfil) || isSuperAdmin"
        slot="dropdown-content"
        :to="{name: 'OptionList'}" class="dropdown-item"
      >
        <span>Afficher options en cours</span>
        <span class="tag is-notification">{{runningOptions.length}}</span>
      </router-link>
      <router-link
        slot="dropdown-content"
        :to="{name: 'LotWishlistList'}" class="dropdown-item"
      >
        <span>Afficher Favoris</span>
        <span class="tag is-notification">{{wishlists.length}}</span>
      </router-link>
      <router-link v-if="isAdmin || isSectorManager"
        slot="dropdown-content"
        :to="{name: 'AccessList'}" class="dropdown-item"
      >
        <span>Afficher mandats</span>
      </router-link>
      <router-link v-if="isAdmin || isEditor"
        slot="dropdown-content"
        :to="{name: 'PromoteurList'}" class="dropdown-item"
      >
        <span>Afficher les promoteurs</span>
      </router-link>
      <router-link v-if="isSuperAdmin"
        slot="dropdown-content"
        :to="{name: 'FluxList'}" class="dropdown-item"
      >
        <span>Afficher les flux</span>
      </router-link>
      <router-link v-if="isAdmin || isEditor"
        slot="dropdown-content"
        :to="{name: 'PromoteurCreate'}" class="dropdown-item"
      >
        <span class="icon"><i class="fas fa-plus-circle"></i></span>
        <span>Nouveau promoteur</span>
      </router-link>
    </sticky>
    <event-notification style="position: relative;"></event-notification>
    <div class="page-content columns collapseColumn collapseColumn--left collapseColumn--alignStart stock"
         id="columns-collapse"
         :class="opened ? 'is-active-collapse' : 'is-inactive-collapse'">
      <div class="column is-3 is-3-widescreen is-3-fullhd">
        <list-filter @resetFilters="resetAllFilters"
                     @changeFilters="submit"
                     @opened="opened = !opened"
                     :displayResetFilters="false"
                     :total="programs.length"
                     :bigTotal="programCount"
                     :loading="countLoading"
                     :hasFilter="hasFilter"
                     :button-label="`${programCount} programme(s)<br>${lotCount} lot(s)`"
                     :criterias-selected="criteriasSelected"
                     :filtersSelected="filtersSelected">
          <button id="filters-button-submit" class="button" type="submit"
                  style="opacity: 0;  position: absolute; left: -5000px">
            Filtrage
          </button>
          <div class="columns" v-if="!isExternal && isDistributeurMode">
            <div class="column is-padding-top-small is-padding-bottom-xsmall">
              <div>
                <multiselect @input="updatePromoteurFilter(promoteursFilter)"
                             v-model="promoteursFilter"
                             label="name" track-by="pk"
                             class="multiselect--option-ico"
                             open-direction="bottom"
                             :multiple="true"
                             :options="promoteurs" :searchable="true" :close-on-select="false" :show-labels="false"
                             @search-change="getPromoteurs" :placeholder="''">
                  <!-- <template slot="clear" slot-scope="props">
                    <div class="multiselect__clear" v-if="promoteursFilter.length"
                         @mousedown.prevent.stop="clearAll(props.search)"></div>
                  </template> -->
                  <span slot="noResult">Oups! Aucun promoteur trouvé.</span>
                  <span slot="placeholder" class="multiselect__placeholder">Promoteur</span>
                  <!-- <span slot="singleLabel" class="multiselect__placeholder">Promoteur</span> -->
                  <span slot="selection" class="multiselect__placeholder" slot-scope="{ values }" v-if="values.length">
                    <span>Promoteur ({{values.length}})</span>
                  </span>
                  <span slot="noOptions">La liste est vide</span>
                </multiselect>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-padding-bottom-xsmall"
                 :class="[(!isExternal && isDistributeurMode) ? 'is-paddingless-top' : 'is-padding-top-small']">
              <div>
                <multiselect v-model="programsFilter" :options="programsFilters"
                              class="multiselect--option-ico is-single_choice"
                              open-direction="bottom"
                              :placeholder="''" track-by="pk" label="name"
                              :multiple="true"
                              :searchable="true" :close-on-select="false" :show-labels="false"
                              @input="updateProgramFilter(programsFilter)"
                              @search-change="getProgramsFilters">
                  <span slot="noResult">Oups! Aucun programme trouvé.</span>
                  <span slot="placeholder" class="multiselect__placeholder">Programmes</span>
                  <!-- <span slot="singleLabel" class="multiselect__placeholder">Programmes</span> -->
                  <span slot="selection" class="multiselect__placeholder" slot-scope="{ values }" v-if="values.length">
                    <span>Programmes ({{values.length}})</span>
                  </span>
                  <span slot="noOptions">La liste est vide</span>
                </multiselect>
              </div>
            </div>
          </div>
          <div class="columns" v-if="filteredRegions && filteredRegions.length">
            <div class="column is-paddingless-top is-padding-bottom-xsmall">
              <div class="no-placeholder">
                <!-- <label for="" class="label">Localisation</label> -->
                <multiselect v-model="stateFilter" name="states" :options="filteredRegions"
                             class="multiselect--option-ico"
                             open-direction="bottom"
                             @input="updateStateFilter(stateFilter)"
                             :multiple="true" :searchable="true" :show-labels="false"
                             :close-on-select="false"  :placeholder="''"
                             group-values="states" group-label="region" :group-select="true"
                             :customLabel="v => stateCustomLabel(v)"
                             label="name" track-by="code">
                  <span slot="noResult">Oups! {{defaultStateLabel.error}}</span>
                  <span slot="placeholder" class="multiselect__placeholder">Région et {{defaultStateLabel.label}}</span>
                  <span slot="selection" class="multiselect__placeholder" slot-scope="{ values }" v-if="values.length">
                    <span>Région et {{defaultStateLabel.label}} ({{values.length}})</span>
                  </span>
                  <span slot="noOptions">La liste est vide</span>
                </multiselect>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-paddingless-top is-padding-bottom-small">
              <div class="no-placeholder" v-if="configs">
                <multiselect v-model="taxDispositifsFilter"
                             label="label"
                             :placeholder="''"
                             track-by="value"
                             @input="updateDispositifsFilter"
                             class="multiselect--option-ico"
                             open-direction="bottom"
                             :options="taxDispositifsList"
                             :searchable="true"
                             :close-on-select="false"
                             :custom-label="dispositifName"
                             :show-labels="false"
                             :disabled="configs.COUNTRY !== 'FRA'"
                             :multiple="true">
                  <template slot="clear" slot-scope="props">
                    <div class="multiselect__clear" v-if="taxDispositifsList.length"
                         @mousedown.prevent.stop="clearAll(props.search)"></div>
                  </template>
                  <span slot="noResult">Oups! Aucun dispositif trouvé.</span>
                  <span slot="placeholder" class="multiselect__placeholder">Dispositifs</span>
                  <span slot="selection" class="multiselect__placeholder" slot-scope="{ values }" v-if="values.length">
                    <span>Dispositifs ({{values.length}})</span>
                  </span>
                  <span slot="noOptions">La liste est vide</span>
                </multiselect>
              </div>
            </div>
          </div>
          <div class="columns is-padding-left is-padding-right" v-if="currency">
            <div class="column is-paddingless-top is-paddingless-left is-paddingless-right is-padding-bottom-small">
              <div class="field">
                <range-chooser :formatter="(value) => `${value / 1000} k`"
                               :loading="bigLoading"
                               :suffix="' k'"
                               :custom-labels="stockBudgetList"
                               :custom-ignore-labels="stockBudgetIgnoreList"
                               :is-slider="true"
                               :re-render="`${fullscreen}${opened}${currency}`"
                               :min="min.price"
                               :max="max.price[currentUserCurrency]"
                               :label="`Budget ${currency}`"
                               :step="stockBudgetStep"
                               :model="[filters.sale_price__gte, filters.sale_price__lte]"
                               @change="updatePriceFilter"
                ></range-chooser>
              </div>
            </div>
          </div>
          <div class="columns is-padding-left is-padding-right is-padding-bottom-small is-multiline">
            <label class="label is-12 column is-paddingless">Livraison</label>
            <div class="column is-12 is-paddingless is-margin-bottom-xxsmall">
              <div class="no-placeholder">
                <multiselect v-model="livraison" :placeholder="''"
                             @input="updateLivraisonFilter"
                             track-by="value" label="label"
                             class="multiselect--option-ico"
                             :options="trimestrialsChoicesByYearObj" :close-on-select="false"
                             :show-labels="false" :multiple="true">
                  <template slot="clear" slot-scope="props">
                    <div class="multiselect__clear" v-if="trimestrialsChoicesByYearObj.length"
                         @mousedown.prevent.stop="clearAll(props.search)"></div>
                  </template>
                  <span slot="placeholder" class="multiselect__placeholder">Années de livraison</span>
                  <span slot="selection" class="multiselect__placeholder" slot-scope="{ values }" v-if="values.length">
                    <span>Années de livraison ({{values.length}})</span>
                  </span>
                </multiselect>
              </div>
            </div>
            <div class="column is-12 is-paddingless">
              <div class="field">
                <input class="checkradiocase is-small is-primary is-fullwidth" id="actability-filter" type="checkbox"
                        :name="actability" v-model="actability"
                        @change="updateActabilityFilter(!actability)">
                  <label for="actability-filter" class="is-radiusless">{{actabilityTermFilter}}</label>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-paddingless">
              <label for="" class="label column is-paddingless-top is-padding-bottom-xsmall">Type</label>
              <div class="column is-paddingless-top is-padding-bottom-small">
                <div class="columns is-variable is-1 is-multiline">
                  <div class="column is-6 is-paddingless-top is-padding-bottom-small"
                       v-for="(n, i) in naturesList" :key="n.value"
                       v-if="['flat', 'house', 'villa'].includes(n.value)" :class="{'is-padding-left-xsmall': i !== 0}">
                    <div class="field">
                      <input class="checkradiocase is-primary is-fullwidth" :id="n.value" type="checkbox"
                             :name="n.value" :value="n.value"
                             :class="{'is-active' : nature.map(x=> x.value).includes(n.value)}"
                             v-model="nature" @change="updateNatureFilter(nature, `#${n.value}`)">
                      <label :for="n.value" class="is-radiusless">{{ n.label }}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-paddingless">
              <div class="columns is-padding-left is-padding-right">
                <div class="column is-paddingless-top is-paddingless-left is-paddingless-right">
                  <div class="field">
                    <range-chooser :loading="bigLoading"
                                  :is-slider="true"
                                  :re-render="`${fullscreen}${opened}`"
                                  :max-steps="null"
                                  :label="`Nombre de ${lotDefaultTypeLabel}`"
                                  :min="min.type" :max="max.type" :step="1"
                                  :model="lotType"
                                  @change="updateLotTypeFilter"
                    ></range-chooser>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="columns is-padding-left is-padding-top is-padding-right is-paddingless-bottom is-multiline" slot="more-criteria">
            <div class="column columns is-paddingless">
              <div class="field column is-paddingless no-placeholder">
                <multiselect v-model="floors" name="floors" :options="floorsList" :placeholder="''"
                             class="multiselect--option-ico is-xsmall"
                             open-direction="bottom"
                             :multiple="true" :searchable="false" :show-labels="false"
                             :close-on-select="false"
                             label="label" track-by="value"
                             @input="updateFloorFilter"
                             @remove="updateFloorFilter(floors)">
                  <span slot="placeholder" class="multiselect__placeholder">Étage</span>
                  <span slot="selection" class="multiselect__placeholder" slot-scope="{ values }" v-if="values.length">
                    <span>Étages ({{values.length}})</span>
                  </span>
                  <span slot="noOptions">La liste est vide</span>
                </multiselect>
              </div>
            </div>
          </div>
          <div class="columns is-padding-left is-padding-top is-padding-right is-paddingless-bottom is-multiline" slot="more-criteria">
            <div class="column columns is-paddingless">
              <div class="field column is-paddingless no-placeholder">
                <multiselect v-model="exposures" name="exposures" :options="exposureList" :placeholder="''"
                             class="multiselect--option-ico is-xsmall"
                             open-direction="bottom"
                             :multiple="true" :searchable="false" :show-labels="false"
                             :close-on-select="false"
                             @input="updateExposureFilter"
                             @remove="updateExposureFilter(exposures)"
                             label="label" track-by="value">
                  <span slot="placeholder" class="multiselect__placeholder">Orientation</span>
                  <span slot="selection" class="multiselect__placeholder" slot-scope="{ values }" v-if="values.length">
                    <span>Orientation ({{values.length}})</span>
                  </span>
                  <span slot="noOptions">La liste est vide</span>
                </multiselect>
              </div>
            </div>
          </div>
          <div class="columns" slot="more-criteria">
            <div class="column is-padding-top-small is-padding-bottom-xsmall">
              <div class="no-placeholder">
                <multiselect v-model="annexType" name="annexes" :options="annexesList.filter(x => !x.hideInFilter)"
                             class="multiselect--option-ico"
                             open-direction="bottom"
                             :placeholder="''" :close-on-select="false"
                             :multiple="true" :searchable="false" :show-labels="false"
                             @input="updateAnnexesFilter"
                             @remove="updateAnnexesFilter(annexType)"
                             label="label" track-by="value">
                  <span slot="placeholder" class="multiselect__placeholder">Annexes</span>
                  <span slot="selection" class="multiselect__placeholder" slot-scope="{ values }" v-if="values.length">
                    <span>Annexes ({{values.length}})</span>
                  </span>
                  <span slot="noOptions">La liste est vide</span>
                </multiselect>
              </div>
            </div>
          </div>
          <div class="columns is-padding-left is-padding-right" slot="more-criteria">
            <div class="column is-paddingless-top is-paddingless-left is-paddingless-right is-paddingless-bottom">
              <div class="field">
                <range-chooser formatter="{value}" :is-slider="true"
                               :loading="bigLoading"
                               @change="updateSurfaceFilter"
                               :re-render="`${fullscreen}${opened}`"
                               :custom-labels="['0', '25', '50', '75', '100']"
                               :min="min.surface"
                               :max="max.surface" :label="'Surface en m²'"
                               :step="25"
                               :model="[filters.surface__gte, filters.surface__lte]">
                </range-chooser>
              </div>
            </div>
          </div>
          <div class="columns" slot="more-criteria">
            <div class="column is-paddingless-top">
              <div class="columns is-variable is-1 is-multiline">
                <div class="column is-paddingless-top is-paddingless-bottom is-margin-top-small is-half" v-for="(n) in naturesList"
                     :key="n.value" v-if="!['flat', 'house', 'villa'].includes(n.value)">
                  <div class="field">
                    <input class="checkradiocase is-primary is-fullwidth" :id="n.value" type="checkbox"
                           :name="n.value" :value="n.value"
                           :class="{'is-active' : nature.map(x=> x.value).includes(n.value)}"
                           v-model="nature" @change="updateNatureFilter(nature, `#${n.value}`)">
                    <label :for="n.value" class="is-radiusless">{{ n.label }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </list-filter>
      </div>
      <div class="column is-9 is-9-widescreen is-10-fullhd"><!-- HB : suppression de 'is-overflow-auto' pr test-->
        <additional-filter :title="'Stock'"
                           :loading="bigLoading"
                           :sort-buttons="currentSortButtons"
                           :currentSort="filters.sort"
                           :hasMargin="false"
                           @sortStock="sortStock">
          <div slot="left-column-title"
               class="column is-paddingless tabs is-separatedUnderlinedX is-marginless-bottom">
            <ul class="has-text-weight-medium is-borderless">
              <li :class="{'is-active' : $route.name === 'StockPrograms'}">
                <router-link :to="{name: 'StockPrograms'}" :class="{'has-bg-light' : $route.name === 'StockPrograms'}">
                  <span class="icon"><i class="fa fa-city"></i></span><span class="is-uppercase">Programmes ({{programCount}})</span>
                </router-link>
              </li>
              <li class="is-border-left" :class="{'is-active' : $route.name === 'StockLots'}">
                <router-link :to="{name: 'StockLots'}" :class="{'has-bg-light' : $route.name === 'StockLots'}">
                  <span class="icon"><i class="fa fa-building"></i></span><span class="is-uppercase">Lots ({{lotCount}})</span>
                </router-link>
              </li>
              <li class="is-border-left is-border-right" :class="{'is-active' : $route.name === 'StockMap'}">
                <router-link :to="{name: 'StockMap'}" :class="{'has-bg-light' : $route.name === 'StockMap'}">
                <span class="icon"><i class="fa fa-map-marker-alt"></i></span><span class="is-uppercase">Géolocalisation</span>
                <!--<span v-if="mapLoading" class="is-padding-left-xsmall"><i class="fal fa-spin fa-spinner"></i></span>-->
              </router-link></li>
            </ul>
          </div>
          <div class="is-padding" slot="filter">
            <label class="label">Statut du lot</label>
            <div class="columns is-multiline is-padding-top-small">
              <div class="control column is-narrow is-paddingless" v-for="p in profilAvailableStatus" :key="p.value">
                <input class="is-checkradio" :id="'lot-' + p.value" type="checkbox" :name="'lot-' + p.value"
                       :value="p.value"
                       v-model="lotsStatus" @change="updateLotStatusFilter(lotsStatus)">
                <label :for="'lot-' + p.value">{{ p.label }}</label>
              </div>
            </div>
          </div>
          <div class="is-border-top is-border-dashed is-padding" slot="filter">
            <label class="label">Statut du programme</label>
            <div class="columns is-multiline is-padding-top-small">
              <div class="control column is-narrow is-paddingless" v-for="s in workflowStatusList" :key="s.value">
                <input class="is-checkradio" :id="'programme-' + s.value" type="checkbox" :name="'programme-' + s.value"
                       :value="s.value"
                       v-model="programStatus" @change="updateProgramStatusFilter(programStatus)">
                <label :for="'programme-' + s.value">{{ s.label }}</label>
              </div>
            </div>
          </div>
          <div v-if="isDistributeurMode" class="is-border-top is-border-dashed columns" slot="filter">
            <div class="column is-border-right is-border-dashed">
              <p class="label">Provenant de flux promoteur</p>
              <div class="control">
                <div class="select">
                  <select v-model="filters.from_flux" @change="updateFluxFilter(filters.from_flux)">
                    <option :value="undefined">Flux Promoteur</option>
                    <option :value="1">Oui</option>
                    <option :value="0">Non</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="is-border-top is-border-dashed columns" slot="filter" v-if="configs && configs.MULTIDIFF_ENABLED === 1">
            <div class="column is-border-right is-border-dashed">
              <label class="label">Multi-diffusion</label>
              <div class="control">
                <div class="select">
                  <select v-model="filters.diffusion_enabled"
                          @change="updateDiffusionFilter(filters.diffusion_enabled)">
                    <option :value="undefined">Etat de la publication</option>
                    <option :value="1">Activée</option>
                    <option :value="0">Désactivée</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="column">
              <label class="label">Date de création</label>
              <div class="field has-addons">
                <div class="control">
                  <a class="button is-square is-static is-border is-min-width-0">
                    <span class="icon"><i class="fas fa-calendar-alt"></i></span>
                  </a>
                </div>
                <div class="control is-expanded has-icons-right">
                  <flat-pickr :config="configDate" v-model="createdDate" class="input is-radiusless"
                              @on-change="updateCreatedDateFilter"
                              name="createdDate"></flat-pickr>
                </div>
                <div class="control">
                  <a class="button is-square is-radiusless" @click="createdDate = null">
                    <i class="fal fa-times"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <template slot="multiselect">
            <div slot="column" class="" v-if="!multiselection">
              <a @click="multiselection = !multiselection" data-tooltip="Sélection multiple"
                class="page-header-btn is-small is-square stock-vue-tooltip tooltip is-tooltip-left is-tooltip-primary">
                <span class="icon"><i class="fas fa-tasks"></i></span>
              </a>
            </div>
            <div slot="column" class="" v-else>
              <a @click="cancelMultiselect"
                class="page-header-btn is-small is-info is-square stock-vue-tooltip tooltip is-tooltip-left is-tooltip-primary"
                data-tooltip="Annuler la sélection">
                <span class="icon"><i class="fas fa-tasks has-text-white"></i></span>
              </a>
            </div>
          </template>
        </additional-filter>
        <div class="is-padding is-border-left is-border-right is-border-bottom has-bg-light" v-if="hasFilter && !loading">
          <label for="" class="is-size-6 label is-padding-bottom-small">Vos critères de recherche :</label>
          <div class="tags">
            <span class="tag is-primary is-rounded" v-if="filters.promoteur && filters.promoteur.length"
                  v-for="(promoteur, i) in promoteursFilter" :key="'promoteur-' + i">
              {{promoteur.name}} <a @click="deletePromoteurFilter(i)" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
            </span>
            <span class="tag is-primary is-rounded" v-if="filters.program && filters.program.length"
                  v-for="(program, i) in programsFilter" :key="'program-' + i">
              {{program.name}} <a @click="deleteProgramFilter(i)" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
            </span>
            <span class="tag is-primary is-rounded" v-if="filters.address__state_code && filters.address__state_code.length"
                  v-for="(state, i) in stateFilter" :key="'state-' + i">
              {{state.name}} <a @click="deleteStateFilter(i)" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
            </span>
            <span class="tag is-primary is-rounded" v-if="filters.tax_dispositifs && filters.tax_dispositifs.length"
                  v-for="(tax, i) in taxDispositifsFilter" :key="'tax-' + i">
              {{tax.label}}<a @click="deleteDispositifsFilter(i)" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
            </span>
            <span class="tag is-primary is-rounded" v-if="filters.sale_price__gte">
              &gt; {{filters.sale_price__gte | prettyAmount}}<a @click="deleteSaleGtFilter()" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
            </span>
            <span class="tag is-primary is-rounded" v-if="filters.sale_price__lte">
              &lt; {{filters.sale_price__lte | prettyAmount}}<a @click="deleteSaleLtFilter()" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
            </span>
            <span class="tag is-primary is-rounded" v-if="filters.date_livraison"
                  v-for="(l, i) in livraison" :key="'livraison-' + i">
              {{l.label}}<a @click="deleteLivraisonFilter(l)" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
            </span>
            <span class="tag is-primary is-rounded" v-if="filters.date_actabilite__lt || filters.date_actabilite__gt">
              {{actabilityTermFilter}} <a @click="updateActabilityFilter(true)" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
            </span>
            <span class="tag is-primary is-rounded" v-if="filters.nature && filters.nature.length"
                  v-for="(n, i) in nature" :key="'nature-' + i">
              {{natureLabel(n)}}<a @click="deleteNatureFilter(i)" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
            </span>
            <span class="tag is-primary is-rounded" v-if="filters.lot_type && filters.lot_type.length">
              {{lotTypeLabel(`T${lotType[0]}`)}} à {{lotTypeLabel(`T${lotType[1]}`)}}<a @click="deleteLotTypeFilter()" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
            </span>
            <span class="tag is-primary is-rounded" v-if="filters.floor && filters.floor.length"
                  v-for="(floor, i) in floors" :key="'floor-' + i">
              {{floor.label}}<a @click="deleteFloorFilter(i)" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
            </span>
            <span class="tag is-primary is-rounded" v-if="filters.exposures && filters.exposures.length"
                  v-for="(exposure, i) in exposures" :key="'exposure-' + i">
              {{exposure.label}}<a @click="deleteExposureFilter(i)" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
            </span>
            <span class="tag is-primary is-rounded" v-if="filters.annexes__annex_type && filters.annexes__annex_type.length"
                  v-for="(annex, i) in annexType" :key="'annex-' + i">
              {{annex.label}}<a @click="deleteAnnexesFilter(i)" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
            </span>
            <span class="tag is-primary is-rounded" v-if="filters.surface__gte">
              &gt; {{filters.surface__gte}} m²<a @click="deleteSurfaceGtFilter()" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
            </span>
            <span class="tag is-primary is-rounded" v-if="filters.surface__lte">
              &lt; {{filters.surface__lte}} m²<a @click="deleteSurfaceLtFilter()" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
            </span>
            <span class="tag is-draft is-rounded has-cursor-pointer" @click="resetAllFilters">
              Réinitialiser les filtres <span class="icon is-white is-margin-left-xsmall"><i class="fas fa-undo"></i></span>
            </span>
          </div>
        </div>

        <router-view :loading="bigLoading"
                     :source-programs="programs"
                     :source-programs-map="programsMap"
                     :map-loading="bigLoading"
                     :source-filters="filters"
                     :source-lots="lots"
                     :params-list="paramsList"
                     :filters="filters"
                     :currentProgramPage="currentProgramPage"
                     :multiselection="multiselection"
                     :selectedItems="selectedItems"
                     :lots-status="lotsStatus"
                     :get-programs-loading="getProgramsLoading"
                     @updateLotStatusFilter="updateLotStatusFilter"
                     @updateProgramFilter="updateProgramFilter"
                     @changePage="changePage"
                     @changePanel="changeProgramPanel"
                     @resetFilters="resetAllFilters"
                     @sort="sortList"
                     @sortPrograms="sortStock"
                     @selectItem="selectItem"
                     @selectItemToggleAll="selectItemToggleAll"
                     @updateStateFilter="updateStateFilter"
                     @loadMore="loadMore"
        ></router-view>
      </div>
    </div>
  </div>
</template>

<script>
  import { bus, EVENTS } from '@/services/bus/index.js'
  import StockFiltersMixin from './StockFiltersMixin'
  import { mapState, mapGetters } from 'vuex'
  import { DefaultValues, GenericList, Filter, Sort, MultiSelection } from '@/mixins'

  const PANELS = Object.freeze({
    StockPrograms: 'StockPrograms',
    StockLots: 'StockLots',
    StockMap: 'StockMap'
  })

  export default {
    name: 'Stock',
    mixins: [DefaultValues, GenericList, Filter, Sort, MultiSelection, StockFiltersMixin],
    data () {
      return {
        fromClick: false,
        loadDocuments: this.loadItems,
        service: this.$api.lotService,
        enableSaveQuery: true,
        selectedLot: null,
        programs: [],
        programsMap: {},
        programCount: 0,
        programLotCount: null,
        totalProgramPage: 1,
        currentProgramPage: 1,
        lotCount: 0,
        loading: false,
        stockLoading: false,
        mapLoading: false,
        programLoading: false,
        loadingFindPrograms: false,
        fullscreen: false,
        PANELS,
        programPanel: 'CARDS',
        perPageMap: 200,
        configDate: {
          altFormat: 'j/m/Y',
          altInput: true,
          dateFormat: 'd/m/Y',
          mode: 'range'
        },
        infiniteLoaderEnabled: true,
        getProgramsLoading: false // added by Timothée
      }
    },
    computed: {
      ...mapState({
        states: 'states',
        scrollToEl: 'scrollToEl',
        scrollToPage: 'scrollToPage',
        runningOptions: 'runningOptions',
        wishlists: 'wishlists',
        configs: 'configs',
        promoteursList: 'promoteurs'}),
      ...mapGetters(['isAdmin', 'isSectorManager', 'isDistributeurMode', 'isEditor', 'isExternal', 'isPromoteurMode', 'currentUserProfil', 'isSuperAdmin', 'configs', 'currentUserCurrency']),
      pastTrimestrials () {
        let choices = this.pastTrimestrialsChoicesByYear.map(x => {
          return x[0]
        })
        return choices.join(';')
      },
      lots () {
        return this.items
      },
      currency () {
        return this.$currency
      },
      actabilityTermFilter () {
        if (!this.configs) return
        let term = {
          FRA: 'Actables',
          MAR: 'Titre foncier disponible'
        }
        return term[this.configs.COUNTRY]
      },
      bigLoading () {
        this.multiselection = false
        this.clearSelectedItems()
        return this.loading || this.programLoading || this.stockLoading || this.countLoading
      },
      selectItemKey () {
        return this.$route.name === 'StockPrograms' ? 'program' : 'pk'
      },
      selectItemArray () {
        return this.$route.name === 'StockPrograms' ? 'programs' : 'items'
      },
      exportData () {
        let query = null
        if (this.selectedItems && this.selectedItems.length) {
          query = this.selectedItems.map(x => `pk[]=${x}`).join('&')
        } else query = Object.assign({}, this.query)
        return {
          url: `${this.$route.name === 'StockLots' ? 'lots' : 'programs'}-export`,
          query
        }
      }
    },
    watch: {
      '$route' (to, from) {
        if (to.name !== from.name) {
          this.watchPageChange(to.name, to.query)
        }
      }
    },
    methods: {
      loadMore (val) {
        this.fromClick = val
        if (this.infiniteLoading) return
        this.getStock({infiniteLoader: true, page: this.nextPage})
      },
      async submit (v) {
        if (v) Object.assign(this.filters, v)
        if (this.stockLoading) return
        this.stockLoading = true
        this.mapLoading = true
        await this.beforeGet()
        await this.getCount(this.filters)
        await this.getStock({})
        this.stockLoading = false
        // this.successScroll()
      },
      async getStock ({infiniteLoader = false, page = null} = null) {
        this.infiniteLoading = true
        if (!infiniteLoader) {
          this.items = []
          this.programs = []
        }
        let func
        if (this.$route.name === 'StockPrograms') {
          func = await this.getPrograms(this.filters, page, infiniteLoader)
        }
        if (this.$route.name === 'StockLots') {
          func = await this.getLots(this.filters, page, infiniteLoader)
        }
        if (this.$route.name === 'StockMap') {
          if (this.programCount > 50 && (!this.filters.address__state_code || !this.filters.address__state_code.length)) {
            func = await this.getMapGeo(this.filters)
          } else {
            func = await this.getProgramsMap(this.filters, true)
          }
        } else {
          this.mapLoading = false
        }
        await Promise.resolve(func).then(() => {
          this.saveHistory(this.filters)
          this.infiniteLoading = false
          if (this.scrollToPage > this.currentProgramPage && this.$route.name === 'StockPrograms') {
            this.programLoading = true
            this.loadMore()
          }
          if (this.scrollToPage > this.currentPage && this.$route.name === 'StockLots') {
            this.loading = true
            this.loadMore()
          }
          if (!this.fromClick) {
            this.successScroll()
          }
          // if (infiniteLoaderState) infiniteLoaderState.loaded()
        })
      },
      async getCount (query) {
        let filters = Object.assign({}, query, {per_page: 1, page: 1})
        this.countLoading = true
        await Promise.all([
          this.$api.programService.getStock(filters),
          this.service.get(filters)
        ]).then(([programs, lots]) => {
          this.programCount = programs.data.total
          this.lotCount = lots.data.total
          this.countLoading = false
        })
      },
      async getPrograms (query, page = null, infiniteLoader = false) {
        if (!infiniteLoader) {
          this.programLoading = true
        }
        let filters = Object.assign({}, query, {per_page: this.perPageProgram, page: (page || this.currentProgramPage)})
        await this.$api.programService.getStock(filters).then(r => {
          if (infiniteLoader) {
            this.programs = this.programs.concat(r.data.items)
          } else {
            this.programs = r.data.items
          }
          this.programLoading = false
          this.currentProgramPage = r.data.page
          this.totalProgramPage = r.data.pages
          // if (this.scrollToPage > r.data.page) {
            //   if (this.programPanel === 'CARDS') {
              //     this.programLoading = true
          //     this.getStock({infiniteLoader: true, page: this.nextPage})
          //   }
          // }
        }).catch(() => {
          this.programLoading = false
        })
      },
      async getLots (query, page = null, infiniteLoader = false) {
        if (!infiniteLoader) {
          this.loading = true
        }
        let filters = Object.assign({}, query, {per_page: this.perPage, page: (page || this.currentPage)})
        await this.$api.lotService.get(filters).then(r => {
          if (infiniteLoader) {
            this.items = this.items.concat(r.data.items)
          } else {
            this.items = r.data.items
          }
          this.loading = false
          this.currentPage = r.data.page
          this.totalPage = r.data.pages
          // if (this.scrollToPage > r.data.page) {
          //   this.loading = true
          //   this.getStock({infiniteLoader: true, page: this.nextPage})
          // }
        }).catch(() => {
          this.loading = false
        })
      },
      async getProgramsMap (query, initPrograms = false, page = 1) {
        let filters = Object.assign({}, query, {per_page: this.perPageMap, page})
        this.mapLoading = true
        this.getProgramsLoading = true // added by Timothée
        try {
          let r = await this.$api.programService.getStock(filters)
          // this.mapLoading = false
          if (initPrograms) this.programsMap = {regionMode: false, data: []}
          let programsPk = this.programsMap.data.map(x => x.pk)
          let newData = r.data.items.filter(x => {
            return !programsPk.includes(x.program)
          })
          this.programsMap.data = this.programsMap.data.concat(newData)
          if (r.data.page < r.data.pages) {
            this.mapLoading = true
            this.getProgramsLoading = true // added by Timothée
            page++
            initPrograms = false
            this.getProgramsMap(query, initPrograms, page)
          } else {
            this.mapLoading = false
            this.getProgramsLoading = false // added by Timothée
          }
        } catch (e) {
          this.mapLoading = false
          this.getProgramsLoading = false // added by Timothée
        }
      },
      getMapGeo (query) {
        let filters = Object.assign({}, query)
        this.mapLoading = true
        this.$api.programService.getGeoRegions(filters).then(r => {
          this.programsMap = {regionMode: true, data: r.data}
          this.mapLoading = false
        }).catch(() => {
          this.mapLoading = false
        })
      },
      afterSuccessGet () {
        this.loading = false
      },
      watchPageChange (to, query) {
        this.multiselection = false
        this.clearSelectedItems()
        Object.assign(this.query, query)
        Object.assign(this.filters, query)
        this.initQueryParams()
        this.changePage(1)
        if (this.programPanel !== 'CARDS') this.programPanel = 'CARDS'
        this.submit(this.filters)
      },
      sortList ({v, e, sortBy}) {
        this.sort(v, e)
        this.sortBy = sortBy
      },
      changePage (v) {
        if (this.$route.name === 'StockLots' && this.currentPage !== v) {
          this.currentPage = v
        } else if (this.$route.name === 'StockPrograms' && this.currentProgramPage !== v) {
          this.currentProgramPage = v
        }
      },
      toggleFullscreen () {
        this.fullscreen = !this.fullscreen
        if (this.fullscreen) {
          document.querySelector('body').classList.add('has-contentmain-fullscreen')
          document.querySelector('body').classList.remove('has-contentmain-fullscreen-leave')
          document.querySelector('.l-header').style.zIndex = '0'
          document.querySelector('.l-navigationmain').style.zIndex = '0'
        } else {
          document.querySelector('body').classList.add('has-contentmain-fullscreen-leave')
          document.querySelector('body').classList.remove('has-contentmain-fullscreen')
          document.querySelector('.l-header').style.zIndex = '36'
          document.querySelector('.l-navigationmain').style.zIndex = '37'
        }
      },
      sortStock ({key, sort, e, sortBy}) {
        this.sort(key, e)
        // this.$set(this.filters, 'sort', `${key}:${sort}`)
        this.sortBy = sortBy
        this.getStock({debounceTime: 0})
      },
      stateCustomLabel (v) {
        if (this.configs.COUNTRY === 'FRA') {
          return `${v.code} - ${v.name}`
        } else {
          return v.name
        }
      }
    },
    async created () {
      Object.assign(this.filters, {}, this.$route.query)
      Object.assign(this.query, {}, this.$route.query)

      if (this.isDistributeurMode) {
        this.promoteurs = this.promoteursList.slice()
        this.filters.program_status = ['available', 'private']
        this.programStatus = ['available', 'private']
        this.initFilters.program_status = ['available', 'private']
      }

      this.getProgramsFilters()

      this.initQueryParams()

      await this.submit(this.filters)
    },
    mounted () {
      document.addEventListener('scroll', this.handleScroll, true)

      // Si le volet est ouvert est que la largeur de l'écran est inférieure à une résolution donnée
      if (this.opened === false && window.innerWidth <= 1280) {
        // let wWidth = window.innerWidth
        // console.log('wWidth', wWidth)
        this.opened = !this.opened
        bus.$emit(EVENTS.RESIZE_TABLE)
      }
      console.log(this.filters)
    },
    destroyed () {
      document.removeEventListener('scroll', this.handleScroll, true)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/stock/StockVue.vue